import { apiClient } from "../../../lib";

export const projectApi = {
    fetchProjects: async (params?: Record<string, any>): Promise<any> => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/projects?${queryString}`);
        return response.data;
    },
    searchProjects: async (params?: Record<string, any>): Promise<any> => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/projects/search?${queryString}`);
        return response.data;
    },
    pinProjects: async ({ id, status }: { id: string, status: boolean }): Promise<any> => {
        const response = status ? await apiClient.post(`/projects/${id}/pinned`) : await apiClient.delete(`/projects/${id}/pinned`);
        return response.data;
    },
    fetchProjectStages: async (params?: Record<string, any>): Promise<any> => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(v => {
                    if (v) searchParams.append(key, String(v));
                });
            } else if (value) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        const response = await apiClient.get(`/projects/quick-filter?${queryString}`);
        return response.data;
    },
    createProject: async (params: Record<string, any>): Promise<any> => {
        const response = await apiClient.post('/projects', params);
        return response.data;
    },
    editProject: async ({ projectId, payload }: { projectId: string, payload: any }): Promise<any> => {
        const response = await apiClient.put(`/projects/${projectId}`, payload);
        return response.data;
    },
    getFormDetails: async (params?: Record<string, any>): Promise<any> => {
        const response = await apiClient.get('/projects/details', {
            params: {
                ...params,
            },
        });
        return response.data;
    },
    getStakeHolders: async (): Promise<any> => {
        const response = await apiClient.get('/projects/stake-holders');
        return response.data;
    },
};